import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["productState"];
import React from 'react';
import AdvancedSearchFooter from '../../../../advanced-search-footer';
import { SearchFooter } from '@atlassian/search-dialog';
export var GetDefaultFooter = function GetDefaultFooter(_ref) {
  var productState = _ref.productState,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(SearchFooter, null, /*#__PURE__*/React.createElement(AdvancedSearchFooter, rest));
};